import { render } from "./TrolleyBox.vue?vue&type=template&id=3a036500"
import script from "./TrolleyBox.vue?vue&type=script&lang=js"
export * from "./TrolleyBox.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__